/**
 * Operational history for scheduled and manually queued service reports.
 * The page displays backend state and asks the backend to retry failed runs; it
 * does not infer report eligibility or mutate status directly.
 */
import { RefreshCw, RotateCcw } from "lucide-react";
import { useEffect, useState } from "react";
import { listReportRuns, retryReportRun } from "./msspApi";

const formatDate = (value) => value ? new Date(value).toLocaleString() : "—";

export default function MsspScheduledReports() {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true); setError("");
    try { setRuns(await listReportRuns()); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const retry = async (id) => {
    setNotice(""); setError("");
    try { await retryReportRun(id); setNotice(`Report run ${id} queued for retry.`); }
    catch (err) { setError(err.message); }
  };

  return (
    <section className="mssp-page">
      <div className="mssp-page-heading"><div><p className="mssp-eyebrow">Automation</p><h1>Service summary reports</h1><p>Track aggregated service reporting separately from WhiteHaX JOB and SCAN_RESULT execution.</p></div><button className="mssp-button secondary" onClick={load}><RefreshCw size={16} /> Refresh</button></div>
      {(notice || error) && <div className={`mssp-alert ${error ? "error" : "success"}`}>{error || notice}</div>}
      <div className="mssp-panel"><div className="mssp-table-wrap"><table className="mssp-table"><thead><tr><th>Run</th><th>Customer</th><th>Service</th><th>Mode</th><th>Period</th><th>Status</th><th>Generated</th><th>Next run</th><th>Recipients</th><th><span className="sr-only">Actions</span></th></tr></thead><tbody>{loading ? <tr><td colSpan="10" className="mssp-empty">Loading report runs…</td></tr> : runs.map((run) => <tr key={run.id}><td>#{run.id}</td><td><strong>{run.companyName}</strong></td><td>{run.serviceName}</td><td><span className="mssp-tier">{run.managementMode.replaceAll("_", " ")}</span></td><td>{run.period}</td><td><span className={`mssp-status ${run.status === "failed" ? "bad" : "good"}`}>{run.status}</span></td><td>{formatDate(run.generatedAt)}</td><td>{formatDate(run.nextRunAt)}</td><td>{run.recipients}</td><td>{run.status === "failed" && <button className="mssp-icon-link button" onClick={() => retry(run.id)} aria-label={`Retry report ${run.id}`}><RotateCcw size={17} /></button>}</td></tr>)}</tbody></table></div></div>
    </section>
  );
}
